module.exports = __webpack_public_path__ + "img/undraw_Mobile_messages_re_yx8w.5cddcbae.svg";